module.exports = __webpack_public_path__ + "img/deixe-seu-curriculo.3aca6676.jpg";